import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { SERVICES } from "@/data/content";

export const ServicesReveal = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="relative overflow-hidden noise-overlay" data-testid="services-overview-section">
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 py-14 md:py-24">
        <SectionHeading
          label="02 — What we do"
          title="Strategy, technology and talent — engineered for measurable impact."
        />
        <div className="mt-16 border-t border-brand-ink/10">
          {SERVICES.map((s, i) => {
            const on = active === i;
            return (
              <Link
                key={s.slug}
                to="/services"
                data-testid={`service-row-${s.slug}`}
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(null)}
                className="group relative flex items-center gap-5 md:gap-10 border-b border-brand-ink/10 py-7 md:py-10"
              >
                <span className="w-10 shrink-0 font-body text-sm tabular-nums text-brand-ink/75 md:w-16">
                  {s.num}
                </span>
                <h3
                  className={`min-w-0 flex-1 break-words font-heading font-black tracking-tight text-3xl md:text-6xl lg:text-[4.2rem] leading-[0.98] transition-all duration-500 group-hover:translate-x-2 md:group-hover:translate-x-4 ${
                    on ? "gradient-text" : "text-brand-ink/85"
                  }`}
                >
                  {s.title}
                </h3>
                <p className="hidden lg:block md:max-w-[16rem] text-sm text-brand-ink/70 leading-relaxed">
                  {s.short}
                </p>
                <span
                  className={`hidden md:flex h-14 w-14 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
                    on ? "border-transparent bg-brand-primary text-white" : "border-brand-ink/15 text-brand-ink"
                  }`}
                >
                  <ArrowUpRight className="h-5 w-5" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
